module.exports = __webpack_public_path__ + "assets/img/icon1 (2).081eb109.png";